module.exports = __webpack_public_path__ + "media/images/need-a-demo-f211eb8f.png";